// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"8f313492","140":"5336ca70","189":"40439333","206":"0e66dcf8","238":"e94c3911","364":"06fee45d","518":"8d396c6b","524":"f8b24b45","608":"2dca76df","618":"3d641396","650":"2b7d94de","771":"2fbdbb9d","791":"eda7f665","892":"fbf5ae48","963":"23bab0d7"}[chunkId] + ".chunk.js";
};